var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3108 5H3.63505C1.89492 5 0.490234 6.34 0.490234 8V12C0.490234 13.1 1.43368 14 2.58678 14H4.68332V16C4.68332 17.1 5.62676 18 6.77986 18H15.166C16.3191 18 17.2626 17.1 17.2626 16V14H19.3591C20.5122 14 21.4556 13.1 21.4556 12V8C21.4556 6.34 20.051 5 18.3108 5ZM14.1177 16H7.82813C7.25158 16 6.77986 15.55 6.77986 15V11H15.166V15C15.166 15.55 14.6943 16 14.1177 16ZM18.3108 9C17.7343 9 17.2626 8.55 17.2626 8C17.2626 7.45 17.7343 7 18.3108 7C18.8874 7 19.3591 7.45 19.3591 8C19.3591 8.55 18.8874 9 18.3108 9ZM16.2143 0H5.73159C5.15504 0 4.68332 0.45 4.68332 1V3C4.68332 3.55 5.15504 4 5.73159 4H16.2143C16.7908 4 17.2626 3.55 17.2626 3V1C17.2626 0.45 16.7908 0 16.2143 0Z",
    fill: "gray"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintRegistration);
export default __webpack_public_path__ + "static/media/print_registration.0a67e1e4.svg";
export { ForwardRef as ReactComponent };